import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { Swiper, SwiperSlide } from "swiper/react";

import {
  fontMerriweather,
  fontRobotoCondensed,
  setFullViewportWidthStyles,
  theme,
  transientOptions,
} from "shared/lib/styles";

import IconArrow from "./icon-arrow.svg";

type ArrowProps = {
  $isDisabled?: boolean;
};
export const Arrow = styled(IconArrow, { ...transientOptions })<ArrowProps>`
  cursor: pointer;
  ${props =>
    props.$isDisabled
      ? css`
          pointer-events: none;
          rect {
            fill: #ffffff;
            stroke: #cccccc;
          }
          rect:first-child {
            fill: #cccccc;
          }
          path {
            fill: #cccccc;
          }
        `
      : css`
          rect {
            fill: transparent;
            stroke: #4585ff;
          }
          rect:first-child {
            fill: #ffffff;
          }
          path {
            fill: #4585ff;
          }
        `}
`;

export const ArrowNext = styled(Arrow)``;

export const ArrowPrevious = styled(Arrow)`
  transform: rotate(180deg);
`;

export const ArrowContainer = styled.div`
  display: flex;
  gap: 8px;

  margin-inline-start: auto;

  ${theme.breakpoints.down("tablet")} {
    display: none;
  }
`;

export const Container = styled.div`
  scroll-margin-top: 70px;

  row-gap: 28px;
`;

export const Header = styled.div`
  display: flex;
  flex-flow: row;
  gap: 8px;
  align-items: center;

  padding-block-end: 8px;

  border-block-end: 1px solid #000000;

  color: #000000;
  font-weight: 400;
  font-size: 20px;
  font-family: ${fontMerriweather};
  font-style: normal;
  line-height: normal;
  font-feature-settings:
    "liga" off,
    "clig" off;
`;

export const List = styled.div`
  overflow: hidden;

  ${theme.breakpoints.down("tablet")} {
    .swiper-wrapper {
      inline-size: fit-content;
    }

    ${setFullViewportWidthStyles()}
  }
`;

export const StyledSwiperSlide = styled(SwiperSlide)`
  &.swiper-slide {
    inline-size: 250px;
    block-size: 425px;
  }
`;

export const StyledSwiper = styled(Swiper)`
  .swiper-wrapper {
    display: flex;

    block-size: auto;
    margin-block-end: 10px;
  }
`;

export const NewBadge = styled.div`
  padding-block: 2px;
  padding-inline: 5px;

  color: #ffffff;
  font-weight: 700;
  font-size: 14px;
  font-family: ${fontRobotoCondensed};
  line-height: 18px;

  border-radius: 4px;

  background: #eb4254;
`;
